// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2bNPN","container":"styles_container__FTjLa","title":"styles_title__30jSU","wrapper":"styles_wrapper__3ZExf","answer":"styles_answer__1D_Ku"};